if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();

      document.addEventListener('matchMobile', () => {
        this.init();
      });

      document.addEventListener('unmatchMobile', () => {
        this.init();
      });

      window.addEventListener('resize', () => {
        this.togglePlpCustomControls();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }

      this.togglePlpCustomControls();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);
      const isPlpCustom = this.section.classList.contains('plp-custom');

      const sliderOptions = {
        slidesPerView: isPlpCustom ? 'auto' : this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
        spaceBetween: isPlpCustom ? 18 : columnGap.tablet,
        slidesOffsetAfter: isPlpCustom ? 306 : 0,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          1024: {
            slidesPerView: isPlpCustom ? 'auto' : parseInt(this.items),
            spaceBetween: isPlpCustom ? 18 : columnGap.tabletLarge,
            slidesOffsetAfter: isPlpCustom ? 286 : 0,
          },
          1280: {
            slidesPerView: isPlpCustom ? 'auto' : parseInt(this.items),
            spaceBetween: isPlpCustom ? 18 : columnGap.desktop,
            slidesOffsetAfter: isPlpCustom ? 306 : 0,
          },
        },
        loop: !isPlpCustom,
        threshold: 2,
        watchOverflow: true,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');

            if (slide && this.sliderInstance && this.sliderInstance.slider) {
              this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            }
          });
        });

        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.on('afterInit', () => {
            this.togglePlpCustomControls();
          });

          this.sliderInstance.slider.on('resize', () => {
            this.togglePlpCustomControls();
          });

          this.sliderInstance.slider.on('update', () => {
            this.togglePlpCustomControls();
          });
        }

        setTimeout(() => {
          this.togglePlpCustomControls();
        }, 150);
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;

          let { target } = e;
          const index = Number(target.dataset.index);

          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideToLoop(index);
          }
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);

      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      this.togglePlpCustomControls();
    }

    togglePlpCustomControls() {
  if (!this.section || !this.section.classList.contains('plp-custom')) return;

  const controls = this.section.querySelector('.swiper-controls');
  const nextButton = this.section.querySelector(this.selectors.nextEl);
  const prevButton = this.section.querySelector(this.selectors.prevEl);

  if (!controls) return;

  const hasSlider = this.enableSlider && this.sliderInstance && this.sliderInstance.slider;

  if (!hasSlider) {
    controls.style.removeProperty('display');
    if (nextButton) nextButton.style.removeProperty('display');
    if (prevButton) prevButton.style.removeProperty('display');
    return;
  }

  controls.classList.remove('hidden');
  controls.style.setProperty('display', 'flex', 'important');

  if (nextButton) {
    nextButton.style.removeProperty('display');
    nextButton.removeAttribute('disabled');
  }

  if (prevButton) {
    prevButton.style.removeProperty('display');
    prevButton.removeAttribute('disabled');
  }

  if (this.sliderInstance.slider.navigation) {
    this.sliderInstance.slider.navigation.update();
  }
}
  }

  customElements.define('collection-list', CollectionList);
}